import axios from "axios";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function JudgeMarkForm(props) {
  const { judge } = props;
  const { setVideoUrl } = props;
  const user_id = props.user_id;
  const audition_id = props.audition_id;
  const round_info_id = props.round_info_id;

  const [submittedError, setSubmittedError] = useState("");
  const [submitted, setSubmitted] = useState("");

  const notify = () => toast.warn("Mark Submitted!");

  const [info, setInfo] = useState({
    mark: "",
    comment: "",
    judge_id: judge.user?.id,
  });
  function handleChange(e) {
    setInfo({ ...info, [e.target.name]: e.target.value });
  }
  function handleSubmit(e) {
    e.preventDefault();
    const fData = new FormData();

    fData.append("audition_id", audition_id);
    fData.append("user_id", user_id);
    fData.append("round_info_id", round_info_id);
    fData.append("judge_mark", info.mark);
    fData.append("judge_comment", info.comment);
    fData.append("judge_id", info.judge_id);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/liveJudgeMarkUpload`, fData)
        .then((res) => {
          if (res.data.status == 200) {
            setSubmitted(res?.data?.message);
            setVideoUrl((prev) => !prev);
          } else {
            setSubmittedError(res?.data?.message);
          }
        });
    });
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <tr>
          <td>{judge.user?.first_name + " " + judge.user?.last_name}</td>
          <td className="mark-number">
            <input
              type="number"
              className="form-control w-100 custom-in-color"
              placeholder="Enter Marks"
              name="mark"
              value={info.mark}
              onChange={handleChange}
            />
            <span className="text-danger">{submittedError}</span>
          </td>
          <td>
            <input
              type="text"
              className="form-control w-100 custom-in-color"
              placeholder="Enter Comments"
              name="comment"
              value={info.comment}
              onChange={handleChange}
            />
          </td>
          <button
            type="submit"
            className="btn btn-sm btn-warning"
            onClick={notify}
          >
            Submit
          </button>
        </tr>
      </form>
      <ToastContainer />
    </div>
  );
}

export default JudgeMarkForm;
